module.exports = __webpack_public_path__ + "static/media/caret.819db820.svg";